// quick-pay.page.ts
import { Component } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';
import { QuickPayService } from 'src/app/services/quick-pay.service';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from 'src/app/services/auth.service';
import { CaseService } from 'src/app/services/case.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quick-pay',
  templateUrl: './quick-pay.page.html',
  styleUrls: ['./quick-pay.page.scss'],
})
export class QuickPayPage {
  orielReferenceNumber: string = '';
  totalAmount: number = 0;
  amountToPay: number = null;
  isAffordable: boolean = false;
  showPaymentDetails: boolean = false; // New flag to control payment details visibility
  isLoading: boolean = false;
  isValidReference: boolean = false; // New flag for reference validation
  showSuccessMessage: boolean = false;
  isProcessingPayment: boolean = false; // Flag to disable pay button during processing
  showCardDetails: boolean = false;
  showMinimumAmountDetails: boolean = false;
  minimumAmount: number = 0;
  paymentDetails: any = {};

  title: string = '`';
  logo_url: string = '';
  footer_title: string = '';
  client = '';
  background_url: string = '';
  datepicker_date_format: string = 'MM/DD/YYYY'
  showNotification: boolean = false;
  login_header_message: string = ''
  login_footer_colour_code: string = ''
  agreement_acceptance: any = {};
  logo_size: string = '60px';
  showInfoIcon = false;
  login_footer_message: string;
  agreement_acceptance_label: string;
   state_disclosures: string;
  showMultipleFieldsMessage: boolean = false;
  full_title_login = null;
  swapFields: {
    primary_field: string;
    secondary_field: string;
    secondary_field_label: string;
  };
 
  checkTranslation = false;
  login_button_label: string;
  // Card details
  cardNumber: string = '';
  expiryDate: string = '';
  cvv: string = '';
  cardName: string = '';
  caseData;

  portalSettings: any = {};
  minLimitMessage = '';
  datemin: string;
  datemax: string;
  trustResult = null;
  constructor(
    private alertController: AlertController,
    private loadingController: LoadingController,
    private quickPayService: QuickPayService,
    private commonService: CommonService,
    private paymentService: PaymentService,
    private authService: AuthService,
    public caseService: CaseService,
    private router: Router,
  ) {}

  ngOnInit() {
    // Set min date to current month/year
    const today = new Date();
    this.datemin = today.toISOString();
    
    // Set max date to 20 years from now
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 20);
    this.datemax = maxDate.toISOString();

    this.fetchSettings();
  }

  fetchSettings() {
    this.authService.portalSettings2().subscribe((res: any) => {
      let portalSettings = res.data;
    
      if (portalSettings?.portal_details?.title) {
        this.title = portalSettings.portal_details.title;
        var domain = new URL(localStorage.getItem('server_url')).hostname.split(
          '.'
        )[0];
        this.client = domain.charAt(0).toUpperCase() + domain.slice(1);
      }

      if (portalSettings?.portal_details?.logo_url) {
        this.logo_url = portalSettings.portal_details.logo_url;
      }
      if (portalSettings?.portal_details?.login_logo_url) {
        this.logo_url = portalSettings.portal_details.login_logo_url;
      }
      if (portalSettings?.portal_details?.background_url) {
        this.background_url = portalSettings.portal_details.background_url;
      }
      if (portalSettings?.datepicker_date_format) {
        this.datepicker_date_format = portalSettings.datepicker_date_format;
      }
      if (portalSettings?.additional_settings?.custom_notifications?.show_notification_panel) {
        this.showNotification = portalSettings.additional_settings.custom_notifications.show_notification_panel;
      }

      //'Having trouble signing in' message. - LU-254
      this.login_header_message = portalSettings?.portal_details?.login_header_message;
      this.login_footer_colour_code = portalSettings?.portal_details?.login_footer_colour_code;
      this.agreement_acceptance = portalSettings?.portal_details?.agreement_acceptance_checkbox;

       if (localStorage.getItem('language') != 'en') {
        console.log(portalSettings?.portal_details);
        console.log(portalSettings?.portal_details?.['agreement_acceptance_label_' + localStorage.getItem('language')]);
        this.agreement_acceptance_label = portalSettings?.portal_details?.['agreement_acceptance_label_' + localStorage.getItem('language')] || portalSettings?.portal_details?.agreement_acceptance_label;
        this.login_footer_message = portalSettings?.portal_details?.['login_footer_message_' + localStorage.getItem('language')] || portalSettings?.portal_details?.login_footer_message;
        this.state_disclosures = portalSettings?.additional_settings?.state_disclosures?.['state_disclosures_' + localStorage.getItem('language')] || portalSettings?.additional_settings?.state_disclosures?.state_disclosures || '';
        this.full_title_login = portalSettings?.portal_details?.['full_title_' + localStorage.getItem('language')] ||  portalSettings?.portal_details?.full_title;
        this.login_button_label = portalSettings?.portal_details?.['login_button_label_' + localStorage.getItem('language')] || portalSettings?.portal_details?.login_button_label;
      }
      else {
        this.agreement_acceptance_label = portalSettings?.portal_details?.agreement_acceptance_label;
        this.login_footer_message = portalSettings?.portal_details?.login_footer_message;
        this.state_disclosures = portalSettings?.additional_settings?.state_disclosures?.state_disclosures;
        this.full_title_login = portalSettings?.portal_details?.full_title;
        this.login_button_label = portalSettings?.portal_details?.login_button_label;
      }
      this.logo_size = portalSettings?.portal_details?.logo_size || '120px';

      this.portalSettings = portalSettings;
      localStorage.setItem('portal_settings', JSON.stringify(portalSettings));

      // Apply theme settings
      if (portalSettings?.theme_settings) {
        this.applyTheme(portalSettings.theme_settings);
      }
    });
  }

  async validateReference() {
    if (!this.orielReferenceNumber) {
      this.showErrorAlert('Error', 'Please enter a reference number');
      return;
    }

    const loading = await this.loadingController.create({
      message: 'Validating reference...',
    });
    await loading.present();

    this.quickPayService.getReferenceDetails(this.orielReferenceNumber).subscribe({
      next: async (response: any) => {
        this.isLoading = false;
        loading.dismiss();

        console.log(response);
        
        if (response.success) {
          // Update the UI with the fetched details
          this.isValidReference = true;
          this.showPaymentDetails = true;
          
          // Set the total amount from the API response, or use a default if not provided
          this.totalAmount = Number(
            parseFloat(response.data?.d_outstanding || 0).toFixed(2)
          );
          
          // Store the case reference and ID for later use
          this.orielReferenceNumber = response.data?.id || this.orielReferenceNumber;
          
          this.caseData = response.data;
            // Removed the validation from here as it's now in proceedToPayment
          // Set a default amount to pay (could be the full amount or a partial amount)
         
        } else {
          this.showErrorAlert('Error', response.message || 'Failed to validate reference number');
        }
      },
      error: async (error) => {
        this.isLoading = false;
        loading.dismiss();
        console.error('Error fetching reference details:', error);
        this.showErrorAlert(
          'Error', 
          error.message || 'An error occurred while validating the reference number. Please try again.'
        );
      }
    });
  }

  async proceedToPayment() {
    if (!this.isAffordable) {
      const alert = await this.alertController.create({
        header: 'Confirmation Required',
        message: 'Please confirm that the payment is affordable for you.',
        buttons: ['OK']
      });
      await alert.present();
      return;
    }
    // Check for minimum payment amount
    
    if (this.portalSettings?.payment_amount_limit_min) {
      const minAmount = parseFloat(this.portalSettings.payment_amount_limit_min);
      
      if (this.amountToPay < minAmount) {
        this.minimumAmount = minAmount;
        this.showPaymentDetails = false;
        this.showCardDetails = false;
        this.showMinimumAmountDetails = true;
        return;
      }
    }

    if (!this.amountToPay || this.amountToPay <= 0 || this.amountToPay > this.totalAmount) {
      const alert = await this.alertController.create({
        header: 'Invalid Amount',
        message: 'Please enter a valid amount to pay.',
        buttons: ['OK']
      });
      await alert.present();
      return;
    }
    this.showPaymentDetails = false;
    this.showCardDetails = true;
    //If all validations pass, proceed with payment processing
  }

   payMinimumAmount() {
    this.amountToPay = this.minimumAmount;
    this.showMinimumAmountDetails = false;
    this.showCardDetails = true;
    this.showPaymentDetails = false;
  }

  openChat() {
    window.open('https://orielcollections.co.uk/', '_blank');
  }
  async processPayment() {
    // First, validate the payment amount
    if (this.amountToPay <= 0 || this.amountToPay > this.totalAmount) {
      await this.showErrorAlert('Invalid Amount', 'Please enter a valid amount to pay.');
      return;
    }

    // Disable the button during processing
    this.isProcessingPayment = true;

    const loading = await this.loadingController.create({
      message: 'Processing payment...',
    });
    
    try {
      await loading.present();
      
      // Create a case data object with the payment details
      const caseData = {
        ...this.caseData,
        id: this.caseData.id,
        amount: this.amountToPay,
        totalAmount: this.totalAmount,
        case_ref: this.caseData.ref,
        d_outstanding: String(this.caseData.d_outstanding || this.totalAmount), // Ensure it's a string
        // Add a flag to indicate this is a quick-pay flow
        isQuickPay: true
      };
      
      // For quick-pay, directly call the payment handler for the default payment method
      const defaultMethod = this.paymentService.defaultPaymentPortal;
      if (defaultMethod && this.paymentService.paymentList[defaultMethod]) {
        // Call the handler directly with the amount pre-filled
        this.paymentService.paymentList[defaultMethod].handler(caseData);
      } else {
        // Fallback to default behavior if no default method is set
        //this.paymentService.navigateToPaymentMethod(caseData);
      }
      this.caseService
        .makeTrustPaymentRequest(caseData.id, { amount: this.amountToPay })
        . subscribe((res: any) => {
          if (res.result) {
              this.trustResult = res.data;
               this.handlePaymentSuccess(this.trustResult, caseData);
          }
      });
    } catch (error) {
        console.error('Payment processing error:', error);
        await this.showErrorAlert('Payment Error', 'An error occurred while processing your payment. Please try again.');
        this.isProcessingPayment = false;
    } finally {
        loading.dismiss();
    }
  }

  async handlePaymentSuccess(trustResult: any, caseData: any) {
    console.log("payment result", trustResult, caseData);
     try {
      const [expiry_month, expiry_year_short] = this.getFormattedExpiryDate().split('/');

      const [firstName, lastName] = (this.cardName || '').trim().split(' ');

      const cardDetails = {
        gateway_id: this.trustResult.id,
        card_number: this.cardNumber.replace(/\s/g, ''),
        expiry_month,
        expiry_year: expiry_year_short,
        cvv: this.cvv,
        debtor_first_name: firstName,
        debtor_last_name: lastName
      };

      this.caseService
        .makeTrustPayment(this.caseData.id, cardDetails)
        .subscribe(
          (res: any) => {
            this.commonService.dismissLoader();
            if (res.result) {
              // Navigate to success page with payment information
              this.router.navigate(['/payment-success'], {
                replaceUrl: true,
                state: {
                  paymentInfo: {
                    referenceNumber: this.orielReferenceNumber,
                    amount: this.amountToPay,
                    transactionId: res.data?.transaction_id || res.data?.id || null
                  },
                  showHeader: false,
                }
              });
            } else {
              this.isProcessingPayment = false;
              this.commonService.showToast(res['message'] || 'Payment failed. Please try again.', 'danger');
            }
          },
          (error) => {
            this.isProcessingPayment = false;
            this.commonService.dismissLoader();
            console.error('Payment error:', error);
            this.showErrorAlert('Payment Error', 'There was an error processing your payment. Please try again.');
          }
        );
      const data = {
        case_ref: this.orielReferenceNumber,
        amount: this.amountToPay,
        totalAmount: this.totalAmount,
      };
      // this.quickPayService.sendPaymentEmail(data).subscribe({
      //   next: async (response: any) => {
      //     if (response.success) {
      //       // Update the UI with the fetched details
      //       this.showPaymentDetails = false;
      //       this.totalAmount = Number(
      //         parseFloat(response.data?.d_outstanding || 0).toFixed(2)
      //       );
      //       // Show success message
      //       this.showSuccessMessage = true;
      //       this.showCardDetails = false;
      //       this.showMinimumAmountDetails = false;
      //       this.router.navigate(['/landing'], { replaceUrl: true });
      //     } else {
      //       this.showErrorAlert('Error', response.message || 'Failed to validate reference number');
      //     }
      //   },
      //   error: async (error) => {
      //     this.showErrorAlert(
      //       'Error',
      //       error.message || 'An error occurred while validating the reference number. Please try again.'
      //     );
      //   }
      // });
      
    } catch (error) {
      console.error('Payment error:', error);
      await this.showErrorAlert('Payment Error', 'There was an error processing your payment. Please try again.');
    } finally {
      //await loading.dismiss();
    }
  }

  // Add this method to handle the "Done" button click
  onDone() {
    this.resetForm();
    this.showSuccessMessage = false;
  }

  goBack() {
  if (this.showPaymentDetails) {
      this.showPaymentDetails = false;
      this.orielReferenceNumber = '';
    }
  if (this.showCardDetails) {
      this.showCardDetails = false;
      this.showMinimumAmountDetails = false;
      this.showPaymentDetails = true;
    }
  if (this.showMinimumAmountDetails) {
      this.showCardDetails = false;
      this.showMinimumAmountDetails = false;
      this.showPaymentDetails = true;
    }
  }

  private resetForm() {
    this.orielReferenceNumber = '';
    this.totalAmount = 0;
    this.amountToPay = null;
    this.isAffordable = false;
    this.showPaymentDetails = false;
    this.showSuccessMessage = false;
    this.showCardDetails = false;
    this.showMinimumAmountDetails = false;
    this.minimumAmount = 0;
    this.isValidReference = false;
    this.cardNumber = '';
    this.expiryDate = '';
    this.cvv = '';
    this.cardName = '';
    this.paymentDetails = {};
  }

  private async showErrorAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header: header,
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }

  // Helper: extract only digits from string
  private digits(s: string): string {
    return (s || '').replace(/\D/g, '');
  }

  // Convert digit index to caret position in formatted string
  private caretFromDigitIndex(formatted: string, digitIndex: number): number {
    let di = 0;
    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) di++;
      if (di >= digitIndex) return i + 1;
    }
    return formatted.length;
  }

  // Format card number: keep up to 16 digits, group into 4s
  private formatCard(v: string): string {
    return this.digits(v).slice(0, 16).replace(/(.{4})/g, '$1 ').trim();
  }

  // Format expiry: MMYY -> MM/YY
  private formatExpiry(v: string): string {
    const d = this.digits(v).slice(0, 4);
    if (d.length <= 2) return d;
    return d.slice(0, 2) + '/' + d.slice(2);
  }

  // Set formatted value while preserving cursor position
  private setFormattedValue(input: HTMLInputElement, formatFn: (v: string) => string): void {
    const old = input.value;
    const caret = input.selectionStart ?? old.length;

    // Count how many digits were before caret
    const digitIndex = this.digits(old.slice(0, caret)).length;

    const formatted = formatFn(old);
    input.value = formatted;

    const newCaret = this.caretFromDigitIndex(formatted, digitIndex);
    input.setSelectionRange(newCaret, newCaret);
  }

  // Format card number with spaces every 4 digits
  formatCardNumber(event: any): void {
    const input = event.target as HTMLInputElement;
    this.setFormattedValue(input, (v) => this.formatCard(v));
    this.cardNumber = input.value;
  }

  // Handle ion-datetime change for expiry date
  onExpiryDateChange(event: any): void {
    const dateValue = event.detail.value;
    if (dateValue) {
      // Store the ISO value for the datetime binding
      this.expiryDate = dateValue;
    }
  }

  // Get formatted expiry date as MM/YY for display/submission
  getFormattedExpiryDate(): string {
    if (!this.expiryDate) return '';
    const date = new Date(this.expiryDate);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${month}/${year}`;
  }

  // Handle paste for card number
  onCardPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const text = event.clipboardData?.getData('text') || '';
    input.value = this.formatCard(text);
    this.cardNumber = input.value;
  }

  applyTheme(themeSettings: any) {
    const root = document.documentElement;

    // Iterate through the theme settings and set CSS variables
    for (const panelKey in themeSettings) {
      if (themeSettings.hasOwnProperty(panelKey)) {
        const colors = themeSettings[panelKey];
        for (const colorKey in colors) {
          if (colors.hasOwnProperty(colorKey)) {
            const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            const target = isDark ? document.body : document.documentElement;
            target.style.setProperty(`--${colorKey.replace(/_/g, '-')}`, colors[colorKey]);
          }
        }
      }
    }
  }
}